import { TrashIcon as Trash } from "@phosphor-icons/react";

export default function SessionsSidebar({
  sessions,
  activeSessionId,
  onSelect,
  onDelete,
}) {
  return (
    <aside
      className="lg:col-span-3 ml-card p-4 h-fit lg:sticky lg:top-24"
      data-testid="sessions-sidebar"
    >
      <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)] mb-3">
        Sessions ({sessions.length})
      </div>
      {sessions.length === 0 ? (
        <div className="text-xs text-[var(--ml-text-secondary)] py-6 text-center">
          No sessions yet. Start typing below.
        </div>
      ) : (
        <ul className="space-y-1 max-h-[60vh] overflow-y-auto">
          {sessions.map((s) => (
            <SessionRow
              key={s.id}
              session={s}
              isActive={activeSessionId === s.id}
              onSelect={onSelect}
              onDelete={onDelete}
            />
          ))}
        </ul>
      )}
    </aside>
  );
}

function SessionRow({ session, isActive, onSelect, onDelete }) {
  return (
    <li>
      <button
        onClick={() => onSelect(session.id)}
        className={`group w-full text-left px-3 py-2 border text-sm flex items-start justify-between gap-2 transition-colors ${
          isActive
            ? "border-[var(--ml-primary)] bg-[var(--ml-primary)]/[0.06]"
            : "border-transparent hover:bg-[var(--ml-surface)] hover:border-[var(--ml-border)]"
        }`}
        data-testid={`session-item-${session.id}`}
      >
        <span className="flex-1 min-w-0">
          <span className="block truncate font-medium">{session.title}</span>
          <span className="ml-mono text-[10px] text-[var(--ml-text-secondary)]">
            {session.message_count} msg ·{" "}
            {new Date(session.updated_at).toLocaleDateString()}
          </span>
        </span>
        <span
          onClick={(e) => onDelete(session.id, e)}
          className="opacity-0 group-hover:opacity-100 text-[var(--ml-error)] hover:bg-[var(--ml-error)]/10 px-1 py-1"
          data-testid={`delete-session-${session.id}`}
          role="button"
          tabIndex={0}
        >
          <Trash size={14} />
        </span>
      </button>
    </li>
  );
}
